<template>
  <section id="billing-automation-rules" class="all-cases-view" v-loading="loading">
    <div class="container-small-table">
      <div class="primary-content-view-new">
        <el-tabs v-model="activeTab" @tab-click="onTabChange">
          <!-- CPT Coverage Tab -->
          <el-tab-pane label="CPT Coverage Rules" name="cpt">
            <div class="listings listings__table listings__all-cases">
              <el-table :data="cptMappings" height="calc(100vh - 220px)">
                <el-table-column label="CPT CODE" min-width="140">
                  <template v-slot="scope">
                    {{ scope.row.cpt_code || "--" }}
                  </template>
                </el-table-column>
                  <el-table-column label="CASE TYPE" min-width="140">
                  <template v-slot="scope">
                    {{ scope.row.case_type || "CLINICAL CHEMISTRY" }}
                  </template>
                </el-table-column>
                <el-table-column label="COVERAGE" min-width="200">
                  <template v-slot="scope">
                    <el-tag v-if="scope.row.all_covered" type="success">All Covered</el-tag>
                    <el-tooltip
                      v-else-if="scope.row.icd_codes && scope.row.icd_codes.length"
                      effect="dark"
                      placement="bottom"
                    >
                      <template #content>
                        <div style="max-width: 300px; white-space: normal; word-break: break-word;">
                          {{ scope.row.icd_codes.slice(0, 50).join(", ") }}
                          <span v-if="scope.row.icd_codes.length > 50">
                            ...and {{ scope.row.icd_codes.length - 50 }} more
                          </span>
                        </div>
                      </template>
                      <span class="icd-codes-preview">
                        {{ scope.row.icd_codes.slice(0, 5).join(", ") }}<span v-if="scope.row.icd_codes.length > 5" class="icd-more-badge">+{{ scope.row.icd_codes.length - 5 }} more</span>
                      </span>
                    </el-tooltip>
                    <span v-else>--</span>
                  </template>
                </el-table-column>
                <el-table-column label="UPDATED BY" min-width="150">
                  <template v-slot="scope">
                    <span v-if="scope.row.updated_by">
                      {{ scope.row.updated_by.first_name }}
                      {{ scope.row.updated_by.last_name }}
                    </span>
                    <span v-else>--</span>
                  </template>
                </el-table-column>
                <el-table-column label="UPDATED AT" min-width="160">
                  <template v-slot="scope">
                    {{ formatDate(scope.row.updated_at) }}
                  </template>
                </el-table-column>
                <el-table-column label="ACTIONS" width="100">
                  <template v-slot="scope">
                    <ul class="listings__action-buttons">
                      <li>
                        <el-button
                          class="view-button"
                          title="Edit"
                          @click="openCptEditDialog(scope.row)"
                        >
                          <img
                            class="action-active"
                            src="@/assets/images/icons/actions/edit-active.svg"
                            alt="icon"
                          />
                          <img
                            class="action-inactive"
                            src="@/assets/images/icons/actions/edit-deactive.svg"
                            alt="icon"
                          />
                        </el-button>
                      </li>
                    </ul>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-tab-pane>

          <!-- ICD Case Type Mappings Tab -->
          <el-tab-pane label="ICD Case Type Mappings" name="icd">
            <div class="listings listings__table listings__all-cases">
              <el-table :data="icdMappings" height="calc(100vh - 220px)">
                <el-table-column label="CASE TYPE" min-width="220">
                  <template v-slot="scope">
                    {{ scope.row.case_type || "--" }}
                  </template>
                </el-table-column>
                <el-table-column label="CATEGORIES" min-width="160">
                  <template v-slot="scope">
                    <span v-if="scope.row.categories && scope.row.categories.length">
                      {{ scope.row.categories.join(", ") }}
                    </span>
                    <span v-else>--</span>
                  </template>
                </el-table-column>
                <el-table-column label="ICD CODES" min-width="250">
                  <template v-slot="scope">
                    <el-tooltip
                      v-if="scope.row.icd_codes && scope.row.icd_codes.length"
                      effect="dark"
                      placement="bottom"
                    >
                      <template #content>
                        <div style="max-width: 300px; white-space: normal; word-break: break-word;">
                          {{ scope.row.icd_codes.slice(0, 50).join(", ") }}
                          <span v-if="scope.row.icd_codes.length > 50">
                            ...and {{ scope.row.icd_codes.length - 50 }} more
                          </span>
                        </div>
                      </template>
                      <span class="icd-codes-preview">
                        {{ scope.row.icd_codes.slice(0, 5).join(", ") }}<span v-if="scope.row.icd_codes.length > 5" class="icd-more-badge">+{{ scope.row.icd_codes.length - 5 }} more</span>
                      </span>
                    </el-tooltip>
                    <span v-else>--</span>
                  </template>
                </el-table-column>
                <el-table-column label="UPDATED BY" min-width="150">
                  <template v-slot="scope">
                    <span v-if="scope.row.updated_by">
                      {{ scope.row.updated_by.username || scope.row.updated_by.last_name }}
                    </span>
                    <span v-else>--</span>
                  </template>
                </el-table-column>
                <el-table-column label="UPDATED AT" min-width="160">
                  <template v-slot="scope">
                    {{ formatDate(scope.row.updated_at) }}
                  </template>
                </el-table-column>
                <el-table-column label="ACTIONS" width="100">
                  <template v-slot="scope">
                    <ul class="listings__action-buttons">
                      <li>
                        <el-button
                          class="view-button"
                          title="Edit"
                          @click="openIcdEditDialog(scope.row)"
                        >
                          <img
                            class="action-active"
                            src="@/assets/images/icons/actions/edit-active.svg"
                            alt="icon"
                          />
                          <img
                            class="action-inactive"
                            src="@/assets/images/icons/actions/edit-deactive.svg"
                            alt="icon"
                          />
                        </el-button>
                      </li>
                    </ul>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-tab-pane>

          <!-- Payer CPT Rules Tab -->
          <el-tab-pane label="Payer CPT Rules" name="payer-cpt">
            <div class="tab-toolbar">
              <el-button type="primary" size="small" @click="openPayerCptDialog(null)">+ Add Rule</el-button>
            </div>
            <div class="listings listings__table listings__all-cases">
              <el-table :data="payerCptRules" height="calc(100vh - 260px)">
                <el-table-column label="RULE NAME" min-width="180">
                  <template v-slot="scope">{{ scope.row.rule_name || "--" }}</template>
                </el-table-column>
                <el-table-column label="CASE TYPES" min-width="200">
                  <template v-slot="scope">
                    <span v-if="scope.row.case_types && scope.row.case_types.length">
                      {{ scope.row.case_types.join(", ") }}
                    </span>
                    <span v-else>--</span>
                  </template>
                </el-table-column>
                <el-table-column label="PAYER PATTERNS" min-width="220">
                  <template v-slot="scope">
                    <span v-if="scope.row.payer_patterns && scope.row.payer_patterns.length">
                      {{ scope.row.payer_patterns.slice(0, 3).join(", ") }}
                      <span v-if="scope.row.payer_patterns.length > 3" class="icd-more-badge">+{{ scope.row.payer_patterns.length - 3 }} more</span>
                    </span>
                    <span v-else>--</span>
                  </template>
                </el-table-column>
                <el-table-column label="UPDATED BY" min-width="150">
                  <template v-slot="scope">
                    <span v-if="scope.row.updated_by">
                      {{ scope.row.updated_by.first_name }} {{ scope.row.updated_by.last_name }}
                    </span>
                    <span v-else>--</span>
                  </template>
                </el-table-column>
                <el-table-column label="UPDATED AT" min-width="160">
                  <template v-slot="scope">{{ formatDate(scope.row.updated_at) }}</template>
                </el-table-column>
                <el-table-column label="ACTIONS" width="100">
                  <template v-slot="scope">
                    <ul class="listings__action-buttons">
                      <li>
                        <el-button class="view-button" title="Edit" @click="openPayerCptDialog(scope.row)">
                          <img class="action-active" src="@/assets/images/icons/actions/edit-active.svg" alt="icon" />
                          <img class="action-inactive" src="@/assets/images/icons/actions/edit-deactive.svg" alt="icon" />
                        </el-button>
                      </li>
                    </ul>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-tab-pane>

          <!-- Sendout CPT Mappings Tab -->
          <el-tab-pane label="Case CPT's" name="sendout-cpt">
            <div class="listings listings__table listings__all-cases">
              <el-table :data="sendoutMappings" height="calc(100vh - 220px)">
                <el-table-column label="LAB ORDER CODE" min-width="180">
                  <template v-slot="scope">{{ scope.row.lab_order_code || "--" }}</template>
                </el-table-column>
                <el-table-column label="CPT CODES" min-width="280">
                  <template v-slot="scope">
                    <span v-if="scope.row.cpt_codes && scope.row.cpt_codes.length">
                      {{ scope.row.cpt_codes.slice(0, 5).map(c => c.code || c).join(", ") }}
                      <span v-if="scope.row.cpt_codes.length > 5" class="icd-more-badge">+{{ scope.row.cpt_codes.length - 5 }} more</span>
                    </span>
                    <span v-else>--</span>
                  </template>
                </el-table-column>
                <el-table-column label="UPDATED BY" min-width="150">
                  <template v-slot="scope">
                    <span v-if="scope.row.updated_by">
                      {{ scope.row.updated_by.first_name }} {{ scope.row.updated_by.last_name }}
                    </span>
                    <span v-else>--</span>
                  </template>
                </el-table-column>
                <el-table-column label="UPDATED AT" min-width="160">
                  <template v-slot="scope">{{ formatDate(scope.row.updated_at) }}</template>
                </el-table-column>
                <el-table-column label="ACTIONS" width="100">
                  <template v-slot="scope">
                    <ul class="listings__action-buttons">
                      <li>
                        <el-button class="view-button" title="Edit" @click="openSendoutDialog(scope.row)">
                          <img class="action-active" src="@/assets/images/icons/actions/edit-active.svg" alt="icon" />
                          <img class="action-inactive" src="@/assets/images/icons/actions/edit-deactive.svg" alt="icon" />
                        </el-button>
                      </li>
                    </ul>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-tab-pane>

          <!-- Tox Payer Group Rules Tab -->
          <el-tab-pane label="Tox Payer Group Rules" name="tox-payer-group">
            <div class="tab-toolbar">
              <el-button type="primary" size="small" @click="openToxPayerGroupDialog(null)">+ Add Rule</el-button>
            </div>
            <div class="listings listings__table listings__all-cases">
              <el-table :data="toxPayerGroupRules" height="calc(100vh - 260px)">
                <el-table-column label="GROUP NAME" min-width="180">
                  <template v-slot="scope">{{ scope.row.group_name || "--" }}</template>
                </el-table-column>
                <el-table-column label="SCREENING CPT" min-width="140">
                  <template v-slot="scope">{{ scope.row.screening_cpt_code || "--" }}</template>
                </el-table-column>
                <el-table-column label="CONFIRMATION CPT" min-width="160">
                  <template v-slot="scope">{{ scope.row.confirmation_cpt_code || "--" }}</template>
                </el-table-column>
                <el-table-column label="PAYER EXACT NAMES" min-width="220">
                  <template v-slot="scope">
                    <el-tooltip
                      v-if="scope.row.payer_exact_names && scope.row.payer_exact_names.length"
                      effect="dark"
                      placement="bottom"
                    >
                      <template #content>
                        <div style="max-width: 300px; white-space: normal; word-break: break-word;">
                          {{ scope.row.payer_exact_names.join(", ") }}
                        </div>
                      </template>
                      <span>
                        {{ scope.row.payer_exact_names.slice(0, 2).join(", ") }}
                        <span v-if="scope.row.payer_exact_names.length > 2" class="icd-more-badge">+{{ scope.row.payer_exact_names.length - 2 }} more</span>
                      </span>
                    </el-tooltip>
                    <span v-else>--</span>
                  </template>
                </el-table-column>
                <el-table-column label="PAYER PATTERNS" min-width="180">
                  <template v-slot="scope">
                    <el-tooltip
                      v-if="scope.row.payer_patterns && scope.row.payer_patterns.length"
                      effect="dark"
                      placement="bottom"
                    >
                      <template #content>
                        <div style="max-width: 300px; white-space: normal; word-break: break-word;">
                          {{ scope.row.payer_patterns.join(", ") }}
                        </div>
                      </template>
                      <span>
                        {{ scope.row.payer_patterns.slice(0, 2).join(", ") }}
                        <span v-if="scope.row.payer_patterns.length > 2" class="icd-more-badge">+{{ scope.row.payer_patterns.length - 2 }} more</span>
                      </span>
                    </el-tooltip>
                    <span v-else>--</span>
                  </template>
                </el-table-column>
                <el-table-column label="EXCLUSION PATTERNS" min-width="200">
                  <template v-slot="scope">
                    <el-tooltip
                      v-if="scope.row.payer_exclusion_patterns && scope.row.payer_exclusion_patterns.length"
                      effect="dark"
                      placement="bottom"
                    >
                      <template #content>
                        <div style="max-width: 300px; white-space: normal; word-break: break-word;">
                          {{ scope.row.payer_exclusion_patterns.join(", ") }}
                        </div>
                      </template>
                      <span>
                        {{ scope.row.payer_exclusion_patterns.slice(0, 2).join(", ") }}
                        <span v-if="scope.row.payer_exclusion_patterns.length > 2" class="icd-more-badge">+{{ scope.row.payer_exclusion_patterns.length - 2 }} more</span>
                      </span>
                    </el-tooltip>
                    <span v-else>--</span>
                  </template>
                </el-table-column>
                <el-table-column label="UPDATED BY" min-width="150">
                  <template v-slot="scope">
                    <span v-if="scope.row.updated_by">
                      {{ scope.row.updated_by.first_name }} {{ scope.row.updated_by.last_name }}
                    </span>
                    <span v-else>--</span>
                  </template>
                </el-table-column>
                <el-table-column label="UPDATED AT" min-width="160">
                  <template v-slot="scope">{{ formatDate(scope.row.updated_at) }}</template>
                </el-table-column>
                <el-table-column label="ACTIONS" width="100" fixed="right">
                  <template v-slot="scope">
                    <ul class="listings__action-buttons">
                      <li>
                        <el-button class="view-button" title="Edit" @click="openToxPayerGroupDialog(scope.row)">
                          <img class="action-active" src="@/assets/images/icons/actions/edit-active.svg" alt="icon" />
                          <img class="action-inactive" src="@/assets/images/icons/actions/edit-deactive.svg" alt="icon" />
                        </el-button>
                      </li>
                    </ul>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-tab-pane>

          <!-- Tox Policy Prefix Rules Tab -->
          <el-tab-pane label="Tox Policy Prefix Rules" name="tox-policy-prefix">
            <div class="listings listings__table listings__all-cases">
              <el-table :data="toxPolicyPrefixRules" height="calc(100vh - 220px)">
                <el-table-column label="RULE NAME" min-width="180">
                  <template v-slot="scope">{{ scope.row.rule_name || "--" }}</template>
                </el-table-column>
                <el-table-column label="POLICY PREFIXES" min-width="200">
                  <template v-slot="scope">
                    <span v-if="scope.row.policy_prefixes && scope.row.policy_prefixes.length">
                      {{ scope.row.policy_prefixes.slice(0, 4).join(", ") }}
                      <span v-if="scope.row.policy_prefixes.length > 4" class="icd-more-badge">+{{ scope.row.policy_prefixes.length - 4 }} more</span>
                    </span>
                    <span v-else>--</span>
                  </template>
                </el-table-column>
                <el-table-column label="CPT CODES" min-width="200">
                  <template v-slot="scope">
                    <span v-if="scope.row.cpt_codes && scope.row.cpt_codes.length">
                      {{ scope.row.cpt_codes.slice(0, 4).map(c => c.cpt_code || c).join(", ") }}
                      <span v-if="scope.row.cpt_codes.length > 4" class="icd-more-badge">+{{ scope.row.cpt_codes.length - 4 }} more</span>
                    </span>
                    <span v-else>--</span>
                  </template>
                </el-table-column>
                <el-table-column label="TOTAL SUM" min-width="120">
                  <template v-slot="scope">{{ scope.row.total_sum != null ? scope.row.total_sum : "--" }}</template>
                </el-table-column>
                <el-table-column label="UPDATED BY" min-width="150">
                  <template v-slot="scope">
                    <span v-if="scope.row.updated_by">
                      {{ scope.row.updated_by.first_name }} {{ scope.row.updated_by.last_name }}
                    </span>
                    <span v-else>--</span>
                  </template>
                </el-table-column>
                <el-table-column label="UPDATED AT" min-width="160">
                  <template v-slot="scope">{{ formatDate(scope.row.updated_at) }}</template>
                </el-table-column>
                <el-table-column label="ACTIONS" width="100">
                  <template v-slot="scope">
                    <ul class="listings__action-buttons">
                      <li>
                        <el-button class="view-button" title="Edit" @click="openToxPolicyPrefixDialog(scope.row)">
                          <img class="action-active" src="@/assets/images/icons/actions/edit-active.svg" alt="icon" />
                          <img class="action-inactive" src="@/assets/images/icons/actions/edit-deactive.svg" alt="icon" />
                        </el-button>
                      </li>
                    </ul>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>

    <!-- CPT Edit Dialog -->
    <el-dialog
      v-model="showCptDialog"
      title="Edit CPT Coverage"
      width="500px"
      @closed="resetCptForm"
    >
      <el-form label-position="top" v-if="cptForm">
        <el-form-item label="CPT Code">
          <el-input v-model="cptForm.cpt_code" disabled />
        </el-form-item>
        <el-form-item label="All Covered">
          <el-switch v-model="cptForm.all_covered" />
        </el-form-item>
        <el-form-item label="ICD Codes" v-if="!cptForm.all_covered">
          <div class="icd-selector">
            <el-input
              v-model="icdSearchQuery"
              placeholder="Search ICD code..."
              clearable
              @input="onIcdSearchInput"
            />
            <div class="icd-count">{{ cptForm.icd_codes.length }} code(s) selected</div>
            <!-- Search Results -->
            <div class="icd-search-results" v-if="icdCodeOptions.length">
              <div v-for="opt in sortedIcdCodeOptions" :key="opt.code" class="icd-result-row">
                <span class="icd-result-code">{{ opt.code }}</span>
                <span class="icd-result-desc" v-if="opt.description"> — {{ opt.description }}</span>
                <el-button 
                  v-if="cptForm.icd_codes.includes(opt.code)" 
                  type="danger" 
                  size="small" 
                  @click="removeIcdCode(cptForm, opt.code)"
                >Remove</el-button>
                <el-button 
                  v-else 
                  type="primary" 
                  size="small" 
                  @click="addIcdCode(cptForm, opt.code)"
                >Add</el-button>
              </div>
              <div v-if="icdSearchLoading" class="icd-loading-row">Loading...</div>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="showCptDialog = false">Cancel</el-button>
        <el-button type="primary" :loading="saving" @click="saveCptMapping">Save</el-button>
      </template>
    </el-dialog>

    <!-- ICD Edit Dialog -->
    <el-dialog
      v-model="showIcdDialog"
      title="Edit ICD Case Type Mapping"
      width="550px"
      @closed="resetIcdForm"
    >
      <el-form label-position="top" v-if="icdForm">
        <el-form-item label="Case Type">
          <el-input v-model="icdForm.case_type" disabled />
        </el-form-item>
        <el-form-item label="Categories">
          <el-select
            v-model="icdForm.categories"
            multiple
            filterable
            allow-create
            default-first-option
            placeholder="Type category and press Enter"
            style="width: 100%"
          >
            <el-option
              v-for="cat in icdForm.categories"
              :key="cat"
              :label="cat"
              :value="cat"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="ICD Codes">
          <div class="icd-selector">
            <el-input
              v-model="icdSearchQuery"
              placeholder="Search ICD code..."
              clearable
              @input="onIcdSearchInput"
            />
            <div class="icd-count">{{ icdForm.icd_codes.length }} code(s) selected</div>
            <!-- Search Results -->
            <div class="icd-search-results" v-if="icdCodeOptions.length">
              <div v-for="opt in sortedIcdCodeOptionsForIcd" :key="opt.code" class="icd-result-row">
                <span class="icd-result-code">{{ opt.code }}</span>
                <span class="icd-result-desc" v-if="opt.description"> — {{ opt.description }}</span>
                <el-button 
                  v-if="icdForm.icd_codes.includes(opt.code)" 
                  type="danger" 
                  size="small" 
                  @click="removeIcdCode(icdForm, opt.code)"
                >Remove</el-button>
                <el-button 
                  v-else 
                  type="primary" 
                  size="small" 
                  @click="addIcdCode(icdForm, opt.code)"
                >Add</el-button>
              </div>
              <div v-if="icdSearchLoading" class="icd-loading-row">Loading...</div>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="showIcdDialog = false">Cancel</el-button>
        <el-button type="primary" :loading="saving" @click="saveIcdMapping">Save</el-button>
      </template>
    </el-dialog>

    <!-- Payer CPT Rules Dialog -->
    <el-dialog
      v-model="showPayerCptDialog"
      :title="payerCptIsNew ? 'Add Payer CPT Rule' : 'Edit Payer CPT Rule'"
      width="620px"
      @closed="resetPayerCptForm"
    >
      <el-form label-position="top" v-if="payerCptForm">
        <el-form-item label="Rule Name">
          <el-input v-model="payerCptForm.rule_name" placeholder="Enter rule name" />
        </el-form-item>
        <el-form-item label="Payer Patterns">
          <el-select
            v-model="payerCptForm.payer_patterns"
            multiple filterable allow-create default-first-option
            placeholder="Type pattern and press Enter"
            style="width: 100%"
          >
            <el-option v-for="p in payerCptForm.payer_patterns" :key="p" :label="p" :value="p" />
          </el-select>
        </el-form-item>
        <el-form-item label="Carrier Codes">
          <el-select
            v-model="payerCptForm.carrier_codes"
            multiple filterable allow-create default-first-option
            placeholder="Type carrier code and press Enter"
            style="width: 100%"
          >
            <el-option v-for="c in payerCptForm.carrier_codes" :key="c" :label="c" :value="c" />
          </el-select>
        </el-form-item>
        <el-form-item label="Case Types">
          <el-select
            v-model="payerCptForm.case_types"
            multiple filterable
            placeholder="Select case types"
            style="width: 100%"
          >
            <el-option v-for="ct in caseTypes" :key="ct" :label="ct" :value="ct" />
          </el-select>
        </el-form-item>
        <el-form-item label="CPT Exclusions">
          <el-select
            v-model="payerCptForm.cpt_exclusions"
            multiple filterable allow-create default-first-option
            placeholder="Type CPT code and press Enter"
            style="width: 100%"
          >
            <el-option v-for="c in payerCptForm.cpt_exclusions" :key="c" :label="c" :value="c" />
          </el-select>
        </el-form-item>
        <el-form-item label="Exclude Categories">
          <el-select
            v-model="payerCptForm.exclude_categories"
            multiple filterable allow-create default-first-option
            placeholder="Type category and press Enter"
            style="width: 100%"
          >
            <el-option v-for="c in payerCptForm.exclude_categories" :key="c" :label="c" :value="c" />
          </el-select>
        </el-form-item>
        <el-form-item label="CPT Unit Overrides (JSON array)">
          <el-input
            v-model="payerCptForm.cpt_unit_overrides"
            type="textarea"
            :rows="3"
            placeholder='e.g. [{"cpt_code": "87798", "unit": 3}]'
            class="json-textarea"
          />
        </el-form-item>
        <el-form-item label="CPT Billed Value Overrides (JSON array)">
          <el-input
            v-model="payerCptForm.cpt_billed_value_overrides"
            type="textarea"
            :rows="3"
            placeholder='e.g. [{"cpt_code": "87798", "billed_value": 100.00}]'
            class="json-textarea"
          />
        </el-form-item>
        <el-form-item label="CPT Additions (JSON array)">
          <el-input
            v-model="payerCptForm.cpt_additions"
            type="textarea"
            :rows="4"
            placeholder='e.g. [{"cpt_code": "87801", "unit": 1, "billed_value": 70.2, "add_if_not_present": true}]'
            class="json-textarea"
          />
        </el-form-item>
        <el-form-item label="Promote Z Codes">
          <el-switch v-model="payerCptForm.promote_z_codes" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="showPayerCptDialog = false">Cancel</el-button>
        <el-button type="primary" :loading="payerCptSaving" @click="savePayerCptRule">Save</el-button>
      </template>
    </el-dialog>

    <!-- Sendout CPT Mappings Dialog -->
    <el-dialog
      v-model="showSendoutDialog"
      :title="sendoutIsNew ? 'Add Sendout CPT Mapping' : 'Edit Sendout CPT Mapping'"
      width="780px"
      @closed="resetSendoutForm"
    >
      <el-form label-position="top" v-if="sendoutForm">
        <el-form-item label="Lab Order Code">
          <el-input
            v-model="sendoutForm.lab_order_code"
            placeholder="Enter lab order code"
            :disabled="!sendoutIsNew"
          />
        </el-form-item>
        <el-form-item label="CPT Codes">
          <div class="cpt-rows-header">
            <span style="flex: 1.2">Code</span>
            <span style="flex: 1.2">Category</span>
            <span style="flex: 1">Billed Value</span>
            <span style="flex: 0.8">Unit</span>
            <span style="flex: 1">Total</span>
            <span style="width: 60px"></span>
          </div>
          <div
            v-for="(item, idx) in sendoutForm.cpt_codes"
            :key="idx"
            class="cpt-code-row"
          >
            <el-input v-model="item.code" placeholder="e.g. 87481" size="small" style="flex: 1.2" />
            <el-input v-model="item.category" placeholder="e.g. UTI" size="small" style="flex: 1.2" />
            <el-input-number
              v-model="item.billed_value"
              :precision="2" :min="0" :controls="false"
              size="small" style="flex: 1"
              @change="recalcTotal(item)"
            />
            <el-input-number
              v-model="item.unit"
              :min="1" :controls="false"
              size="small" style="flex: 0.8"
              @change="recalcTotal(item)"
            />
            <el-input-number
              v-model="item.total"
              :precision="2" :min="0" :controls="false"
              size="small" style="flex: 1"
            />
            <el-button
              type="danger" size="small" plain
              style="width: 60px; flex-shrink: 0"
              @click="removeCptCodeRow(idx)"
            >Remove</el-button>
          </div>
          <el-button size="small" style="margin-top: 8px" @click="addCptCodeRow">+ Add Row</el-button>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="showSendoutDialog = false">Cancel</el-button>
        <el-button type="primary" :loading="sendoutSaving" @click="saveSendoutMapping">Save</el-button>
      </template>
    </el-dialog>

    <!-- Tox Payer Group Rules Dialog -->
    <el-dialog
      v-model="showToxPayerGroupDialog"
      :title="toxPayerGroupIsNew ? 'Add Tox Payer Group Rule' : 'Edit Tox Payer Group Rule'"
      width="680px"
      @closed="resetToxPayerGroupForm"
    >
      <el-form label-position="top" v-if="toxPayerGroupForm">
        <el-form-item label="Group Name">
          <el-input v-model="toxPayerGroupForm.group_name" placeholder="Enter group name" />
        </el-form-item>

        <el-form-item label="Payer Exact Names">
          <div class="string-list">
            <div v-for="(_, idx) in toxPayerGroupForm.payer_exact_names" :key="idx" class="string-list-row">
              <el-input
                v-model="toxPayerGroupForm.payer_exact_names[idx]"
                placeholder="e.g. AETNA"
                size="small"
                style="flex: 1"
              />
              <el-button type="danger" size="small" plain @click="removeStringItem(toxPayerGroupForm.payer_exact_names, idx)">Remove</el-button>
            </div>
            <el-button size="small" style="margin-top: 6px" @click="toxPayerGroupForm.payer_exact_names.push('')">+ Add Name</el-button>
          </div>
        </el-form-item>

        <el-form-item label="Payer Patterns">
          <div class="string-list">
            <div v-for="(_, idx) in toxPayerGroupForm.payer_patterns" :key="idx" class="string-list-row">
              <el-input
                v-model="toxPayerGroupForm.payer_patterns[idx]"
                placeholder="e.g. BCBS"
                size="small"
                style="flex: 1"
              />
              <el-button type="danger" size="small" plain @click="removeStringItem(toxPayerGroupForm.payer_patterns, idx)">Remove</el-button>
            </div>
            <el-button size="small" style="margin-top: 6px" @click="toxPayerGroupForm.payer_patterns.push('')">+ Add Pattern</el-button>
          </div>
        </el-form-item>

        <el-form-item label="Payer Exclusion Patterns">
          <div class="string-list">
            <div v-for="(_, idx) in toxPayerGroupForm.payer_exclusion_patterns" :key="idx" class="string-list-row">
              <el-input
                v-model="toxPayerGroupForm.payer_exclusion_patterns[idx]"
                placeholder="e.g. BCBS ARKANSAS"
                size="small"
                style="flex: 1"
              />
              <el-button type="danger" size="small" plain @click="removeStringItem(toxPayerGroupForm.payer_exclusion_patterns, idx)">Remove</el-button>
            </div>
            <el-button size="small" style="margin-top: 6px" @click="toxPayerGroupForm.payer_exclusion_patterns.push('')">+ Add Exclusion</el-button>
          </div>
        </el-form-item>

        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="Screening CPT Code">
              <el-input v-model="toxPayerGroupForm.screening_cpt_code" placeholder="e.g. 80307" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Screening Billed Value">
              <el-input-number
                v-model="toxPayerGroupForm.screening_billed_value"
                :precision="2" :min="0" :controls="false"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="Confirmation CPT Code">
              <el-input v-model="toxPayerGroupForm.confirmation_cpt_code" placeholder="e.g. G0480" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Confirmation Billed Value">
              <el-input-number
                v-model="toxPayerGroupForm.confirmation_billed_value"
                :precision="2" :min="0" :controls="false"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="Active">
          <el-switch v-model="toxPayerGroupForm.is_active" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="showToxPayerGroupDialog = false">Cancel</el-button>
        <el-button type="primary" :loading="toxPayerGroupSaving" @click="saveToxPayerGroupRule">Save</el-button>
      </template>
    </el-dialog>

    <!-- Tox Policy Prefix Rules Dialog -->
    <el-dialog
      v-model="showToxPolicyPrefixDialog"
      :title="toxPolicyPrefixIsNew ? 'Add Tox Policy Prefix Rule' : 'Edit Tox Policy Prefix Rule'"
      width="700px"
      @closed="resetToxPolicyPrefixForm"
    >
      <el-form label-position="top" v-if="toxPolicyPrefixForm">
        <el-form-item label="Rule Name">
          <el-input v-model="toxPolicyPrefixForm.rule_name" placeholder="Enter rule name" />
        </el-form-item>

        <el-form-item label="Policy Prefixes">
          <div class="string-list">
            <div v-for="(_, idx) in toxPolicyPrefixForm.policy_prefixes" :key="idx" class="string-list-row">
              <el-input
                v-model="toxPolicyPrefixForm.policy_prefixes[idx]"
                placeholder="e.g. EXX"
                size="small"
                style="flex: 1"
              />
              <el-button type="danger" size="small" plain @click="removeStringItem(toxPolicyPrefixForm.policy_prefixes, idx)">Remove</el-button>
            </div>
            <el-button size="small" style="margin-top: 6px" @click="toxPolicyPrefixForm.policy_prefixes.push('')">+ Add Prefix</el-button>
          </div>
        </el-form-item>

        <el-form-item label="CPT Codes">
          <div class="cpt-rows-header">
            <span style="flex: 1.2">CPT Code</span>
            <span style="flex: 0.8">Unit</span>
            <span style="flex: 1">Charge</span>
            <span style="flex: 1">Total</span>
            <span style="width: 76px"></span>
          </div>
          <div v-for="(item, idx) in toxPolicyPrefixForm.cpt_codes" :key="idx" class="cpt-code-row">
            <el-input v-model="item.cpt_code" placeholder="e.g. 80307" size="small" style="flex: 1.2" />
            <el-input-number v-model="item.unit" :min="1" :controls="false" size="small" style="flex: 0.8" @change="recalcPrefixTotal(item)" />
            <el-input-number v-model="item.charge" :precision="3" :min="0" :controls="false" size="small" style="flex: 1" @change="recalcPrefixTotal(item)" />
            <el-input-number v-model="item.total" :precision="3" :min="0" :controls="false" size="small" style="flex: 1" />
            <el-button type="danger" size="small" plain style="width: 76px; flex-shrink: 0" @click="toxPolicyPrefixForm.cpt_codes.splice(idx, 1)">Remove</el-button>
          </div>
          <el-button size="small" style="margin-top: 8px" @click="toxPolicyPrefixForm.cpt_codes.push({ cpt_code: '', unit: 1, charge: null, total: null })">+ Add Row</el-button>
        </el-form-item>

        <el-form-item label="Total Sum">
          <el-input-number
            v-model="toxPolicyPrefixForm.total_sum"
            :precision="2" :min="0" :controls="false"
            style="width: 100%"
          />
        </el-form-item>
        <el-form-item label="Active">
          <el-switch v-model="toxPolicyPrefixForm.is_active" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="showToxPolicyPrefixDialog = false">Cancel</el-button>
        <el-button type="primary" :loading="toxPolicyPrefixSaving" @click="saveToxPolicyPrefixRule">Save</el-button>
      </template>
    </el-dialog>
  </section>
</template>

<script>
import { mapGetters } from "vuex"
import moment from "moment-timezone"
import axios from "@/config/axios"
import { ElMessageBox } from "element-plus"
import caseConstants from "@/config/constants/caseConstants"
import {
  successNotification,
  errorNotification,
} from "@/helpers/notifications"

export default {
  data() {
    return {
      activeTab: "cpt",
      loading: false,
      saving: false,
      caseTypes: caseConstants.CASE_TYPES,
      cptMappings: [],
      icdMappings: [],
      showCptDialog: false,
      showIcdDialog: false,
      cptForm: null,
      icdForm: null,
      cptFormOriginalIcdCodes: [],
      icdFormOriginalIcdCodes: [],
      icdCodeOptions: [],
      icdSearchLoading: false,
      icdPage: 1,
      icdHasMore: true,
      icdCurrentQuery: "",
      icdSearchQuery: "",
      showIcdDropdown: false,
      icdSearchTimer: null,

      // Payer CPT Rules
      payerCptRules: [],
      showPayerCptDialog: false,
      payerCptForm: null,
      payerCptIsNew: false,
      payerCptSaving: false,

      // Sendout CPT Mappings
      sendoutMappings: [],
      showSendoutDialog: false,
      sendoutForm: null,
      sendoutIsNew: false,
      sendoutSaving: false,

      // Tox Payer Group Rules
      toxPayerGroupRules: [],
      showToxPayerGroupDialog: false,
      toxPayerGroupForm: null,
      toxPayerGroupIsNew: false,
      toxPayerGroupSaving: false,

      // Tox Policy Prefix Rules
      toxPolicyPrefixRules: [],
      showToxPolicyPrefixDialog: false,
      toxPolicyPrefixForm: null,
      toxPolicyPrefixIsNew: false,
      toxPolicyPrefixSaving: false,
    }
  },

  computed: {
    ...mapGetters("auth", ["getUserPrimaryLabId"]),
    ...mapGetters("icd10Codes", ["getAllIcd10Codes"]),
    sortedIcdCodeOptions() {
      if (!this.cptForm) return this.icdCodeOptions
      const selectedCodes = new Set(this.cptForm.icd_codes || [])
      const searchQuery = (this.icdCurrentQuery || "").trim().toUpperCase()
      return [...this.icdCodeOptions].sort((a, b) => {
        // Exact matches at top first
        if (searchQuery) {
          const aExact = a.code.toUpperCase() === searchQuery
          const bExact = b.code.toUpperCase() === searchQuery
          if (aExact && !bExact) return -1
          if (!aExact && bExact) return 1
          // Then starts with search query
          const aStarts = a.code.toUpperCase().startsWith(searchQuery)
          const bStarts = b.code.toUpperCase().startsWith(searchQuery)
          if (aStarts && !bStarts) return -1
          if (!aStarts && bStarts) return 1
        }
        // Then selected codes
        const aSelected = selectedCodes.has(a.code)
        const bSelected = selectedCodes.has(b.code)
        if (aSelected && !bSelected) return -1
        if (!aSelected && bSelected) return 1
        return 0
      })
    },
    sortedIcdCodeOptionsForIcd() {
      if (!this.icdForm) return this.icdCodeOptions
      const selectedCodes = new Set(this.icdForm.icd_codes || [])
      const searchQuery = (this.icdCurrentQuery || "").trim().toUpperCase()
      return [...this.icdCodeOptions].sort((a, b) => {
        // Exact matches at top first
        if (searchQuery) {
          const aExact = a.code.toUpperCase() === searchQuery
          const bExact = b.code.toUpperCase() === searchQuery
          if (aExact && !bExact) return -1
          if (!aExact && bExact) return 1
          // Then starts with search query
          const aStarts = a.code.toUpperCase().startsWith(searchQuery)
          const bStarts = b.code.toUpperCase().startsWith(searchQuery)
          if (aStarts && !bStarts) return -1
          if (!aStarts && bStarts) return 1
        }
        // Then selected codes
        const aSelected = selectedCodes.has(a.code)
        const bSelected = selectedCodes.has(b.code)
        if (aSelected && !bSelected) return -1
        if (!aSelected && bSelected) return 1
        return 0
      })
    },
    // CPT form: codes that were removed (in original but not in current)
    cptRemovedIcdCodes() {
      if (!this.cptForm) return []
      const currentSet = new Set(this.cptForm.icd_codes)
      return this.cptFormOriginalIcdCodes.filter(code => !currentSet.has(code))
    },
    // ICD form: codes that were removed (in original but not in current)
    icdRemovedIcdCodes() {
      if (!this.icdForm) return []
      const currentSet = new Set(this.icdForm.icd_codes)
      return this.icdFormOriginalIcdCodes.filter(code => !currentSet.has(code))
    },
  },

  mounted() {
    this.fetchCptMappings()
  },

  methods: {
    onTabChange() {
      if (this.activeTab === "cpt") {
        this.fetchCptMappings()
      } else if (this.activeTab === "icd") {
        this.fetchIcdMappings()
      } else if (this.activeTab === "payer-cpt") {
        this.fetchPayerCptRules()
      } else if (this.activeTab === "sendout-cpt") {
        this.fetchSendoutMappings()
      } else if (this.activeTab === "tox-payer-group") {
        this.fetchToxPayerGroupRules()
      } else if (this.activeTab === "tox-policy-prefix") {
        this.fetchToxPolicyPrefixRules()
      }
    },

    async fetchCptMappings() {
      if (!this.getUserPrimaryLabId) return
      this.loading = true
      try {
        const { data } = await axios.get(
          `cpt-icd-mappings/lab/${this.getUserPrimaryLabId}`
        )
        this.cptMappings = data.data || []
      } catch {
        errorNotification("Failed to load CPT coverage rules")
      } finally {
        this.loading = false
      }
    },

    async fetchIcdMappings() {
      this.loading = true
      try {
        const { data } = await axios.get("cpt-icd-mappings/icd-coverage")
        this.icdMappings = data.data || []
      } catch {
        errorNotification("Failed to load ICD case type mappings")
      } finally {
        this.loading = false
      }
    },

    async fetchPayerCptRules() {
      this.loading = true
      try {
        const { data } = await axios.get("billing-config/payer-cpt-rules")
        this.payerCptRules = data.data || []
      } catch {
        errorNotification("Failed to load payer CPT rules")
      } finally {
        this.loading = false
      }
    },

    async fetchSendoutMappings() {
      this.loading = true
      try {
        const { data } = await axios.get("billing-config/sendout-cpt-mappings")
        this.sendoutMappings = data.data || []
      } catch {
        errorNotification("Failed to load sendout CPT mappings")
      } finally {
        this.loading = false
      }
    },

    async fetchToxPayerGroupRules() {
      this.loading = true
      try {
        const { data } = await axios.get("billing-config/tox-payer-group-rules")
        this.toxPayerGroupRules = data.data || []
      } catch {
        errorNotification("Failed to load tox payer group rules")
      } finally {
        this.loading = false
      }
    },

    async fetchToxPolicyPrefixRules() {
      this.loading = true
      try {
        const { data } = await axios.get("billing-config/tox-policy-prefix-rules")
        this.toxPolicyPrefixRules = data.data || []
      } catch {
        errorNotification("Failed to load tox policy prefix rules")
      } finally {
        this.loading = false
      }
    },

    openCptEditDialog(row) {
      this.cptFormOriginalIcdCodes = [...(row.icd_codes || [])]
      this.cptForm = {
        cpt_code: row.cpt_code,
        all_covered: row.all_covered,
        icd_codes: [...(row.icd_codes || [])],
      }
      this.icdPage = 1
      this.icdHasMore = true
      this.icdCurrentQuery = ""
      this.icdSearchQuery = ""
      this.showIcdDropdown = false
      this.showCptDialog = true
      this.loadIcdCodes(false)
    },

    openIcdEditDialog(row) {
      this.icdFormOriginalIcdCodes = [...(row.icd_codes || [])]
      this.icdForm = {
        case_type: row.case_type,
        categories: [...(row.categories || [])],
        icd_codes: [...(row.icd_codes || [])],
      }
      this.icdPage = 1
      this.icdHasMore = true
      this.icdCurrentQuery = ""
      this.icdSearchQuery = ""
      this.showIcdDropdown = false
      this.showIcdDialog = true
      this.loadIcdCodes(false)
    },

    openPayerCptDialog(row) {
      this.payerCptIsNew = !row
      this.payerCptForm = row
        ? {
            _id: row._id,
            rule_name: row.rule_name || "",
            payer_patterns: [...(row.payer_patterns || [])],
            carrier_codes: [...(row.carrier_codes || [])],
            case_types: [...(row.case_types || [])],
            cpt_exclusions: [...(row.cpt_exclusions || [])],
            exclude_categories: [...(row.exclude_categories || [])],
            cpt_unit_overrides: JSON.stringify(row.cpt_unit_overrides || [], null, 2),
            cpt_billed_value_overrides: JSON.stringify(row.cpt_billed_value_overrides || [], null, 2),
            cpt_additions: JSON.stringify(row.cpt_additions || [], null, 2),
            promote_z_codes: !!row.promote_z_codes,
          }
        : {
            _id: null,
            rule_name: "",
            payer_patterns: [],
            carrier_codes: [],
            case_types: [],
            cpt_exclusions: [],
            exclude_categories: [],
            cpt_unit_overrides: "[]",
            cpt_billed_value_overrides: "[]",
            cpt_additions: "[]",
            promote_z_codes: false,
          }
      this.showPayerCptDialog = true
    },

    openSendoutDialog(row) {
      this.sendoutIsNew = !row
      this.sendoutForm = row
        ? {
            _id: row._id,
            lab_order_code: row.lab_order_code || "",
            cpt_codes: (row.cpt_codes || []).map(c => ({ ...c })),
          }
        : {
            _id: null,
            lab_order_code: "",
            cpt_codes: [],
          }
      this.showSendoutDialog = true
    },

    openToxPayerGroupDialog(row) {
      this.toxPayerGroupIsNew = !row
      this.toxPayerGroupForm = row
        ? {
            _id: row._id,
            group_name: row.group_name || "",
            payer_exact_names: [...(row.payer_exact_names || [])],
            payer_patterns: [...(row.payer_patterns || [])],
            payer_exclusion_patterns: [...(row.payer_exclusion_patterns || [])],
            screening_cpt_code: row.screening_cpt_code || "",
            screening_billed_value: row.screening_billed_value ?? null,
            confirmation_cpt_code: row.confirmation_cpt_code || "",
            confirmation_billed_value: row.confirmation_billed_value ?? null,
            is_active: row.is_active !== false,
          }
        : {
            _id: null,
            group_name: "",
            payer_exact_names: [],
            payer_patterns: [],
            payer_exclusion_patterns: [],
            screening_cpt_code: "",
            screening_billed_value: null,
            confirmation_cpt_code: "",
            confirmation_billed_value: null,
            is_active: true,
          }
      this.showToxPayerGroupDialog = true
    },

    openToxPolicyPrefixDialog(row) {
      this.toxPolicyPrefixIsNew = !row
      this.toxPolicyPrefixForm = row
        ? {
            _id: row._id,
            rule_name: row.rule_name || "",
            policy_prefixes: [...(row.policy_prefixes || [])],
            cpt_codes: (row.cpt_codes || []).map(c => ({ ...c })),
            total_sum: row.total_sum ?? null,
            is_active: row.is_active !== false,
          }
        : {
            _id: null,
            rule_name: "",
            policy_prefixes: [],
            cpt_codes: [],
            total_sum: null,
            is_active: true,
          }
      this.showToxPolicyPrefixDialog = true
    },

    async savePayerCptRule() {
      this.payerCptSaving = true
      try {
        let cpt_unit_overrides = []
        let cpt_billed_value_overrides = []
        let cpt_additions = []
        try { cpt_unit_overrides = JSON.parse(this.payerCptForm.cpt_unit_overrides || "[]") } catch { errorNotification("Invalid JSON in CPT Unit Overrides"); return }
        try { cpt_billed_value_overrides = JSON.parse(this.payerCptForm.cpt_billed_value_overrides || "[]") } catch { errorNotification("Invalid JSON in CPT Billed Value Overrides"); return }
        try { cpt_additions = JSON.parse(this.payerCptForm.cpt_additions || "[]") } catch { errorNotification("Invalid JSON in CPT Additions"); return }

        const payload = {
          rule_name: this.payerCptForm.rule_name,
          payer_patterns: this.payerCptForm.payer_patterns,
          carrier_codes: this.payerCptForm.carrier_codes,
          case_types: this.payerCptForm.case_types,
          cpt_exclusions: this.payerCptForm.cpt_exclusions,
          exclude_categories: this.payerCptForm.exclude_categories,
          cpt_unit_overrides,
          cpt_billed_value_overrides,
          cpt_additions,
          promote_z_codes: this.payerCptForm.promote_z_codes,
        }

        if (this.payerCptIsNew) {
          await axios.post("billing-config/payer-cpt-rules", payload)
          successNotification("Payer CPT rule created")
        } else {
          await axios.put(`billing-config/payer-cpt-rules/${this.payerCptForm._id}`, payload)
          successNotification("Payer CPT rule updated")
        }
        this.showPayerCptDialog = false
        this.fetchPayerCptRules()
      } catch {
        errorNotification("Failed to save payer CPT rule")
      } finally {
        this.payerCptSaving = false
      }
    },

    async deletePayerCptRule(row) {
      try {
        await ElMessageBox.confirm(
          `Delete rule "${row.rule_name}"? This cannot be undone.`,
          "Confirm Delete",
          { confirmButtonText: "Delete", cancelButtonText: "Cancel", type: "warning" }
        )
        await axios.delete(`billing-config/payer-cpt-rules/${row._id}`)
        successNotification("Payer CPT rule deleted")
        this.fetchPayerCptRules()
      } catch (e) {
        if (e !== "cancel") errorNotification("Failed to delete payer CPT rule")
      }
    },

    async saveSendoutMapping() {
      this.sendoutSaving = true
      try {
        const payload = {
          lab_order_code: this.sendoutForm.lab_order_code,
          cpt_codes: this.sendoutForm.cpt_codes,
        }
        if (this.sendoutIsNew) {
          await axios.post("billing-config/sendout-cpt-mappings", payload)
          successNotification("Sendout CPT mapping created")
        } else {
          await axios.put(`billing-config/sendout-cpt-mappings/${this.sendoutForm.lab_order_code}`, payload)
          successNotification("Sendout CPT mapping updated")
        }
        this.showSendoutDialog = false
        this.fetchSendoutMappings()
      } catch {
        errorNotification("Failed to save sendout CPT mapping")
      } finally {
        this.sendoutSaving = false
      }
    },

    async deleteSendoutMapping(row) {
      try {
        await ElMessageBox.confirm(
          `Delete mapping for "${row.lab_order_code}"? This cannot be undone.`,
          "Confirm Delete",
          { confirmButtonText: "Delete", cancelButtonText: "Cancel", type: "warning" }
        )
        await axios.delete(`billing-config/sendout-cpt-mappings/${row._id || row.lab_order_code}`)
        successNotification("Sendout CPT mapping deleted")
        this.fetchSendoutMappings()
      } catch (e) {
        if (e !== "cancel") errorNotification("Failed to delete sendout CPT mapping")
      }
    },

    async saveToxPayerGroupRule() {
      this.toxPayerGroupSaving = true
      try {
        const payload = {
          group_name: this.toxPayerGroupForm.group_name,
          payer_exact_names: this.toxPayerGroupForm.payer_exact_names.filter(v => v.trim()),
          payer_patterns: this.toxPayerGroupForm.payer_patterns.filter(v => v.trim()),
          payer_exclusion_patterns: this.toxPayerGroupForm.payer_exclusion_patterns.filter(v => v.trim()),
          screening_cpt_code: this.toxPayerGroupForm.screening_cpt_code,
          screening_billed_value: this.toxPayerGroupForm.screening_billed_value,
          confirmation_cpt_code: this.toxPayerGroupForm.confirmation_cpt_code,
          confirmation_billed_value: this.toxPayerGroupForm.confirmation_billed_value,
          is_active: this.toxPayerGroupForm.is_active,
        }
        if (this.toxPayerGroupIsNew) {
          await axios.post("billing-config/tox-payer-group-rules", payload)
          successNotification("Tox payer group rule created")
        } else {
          await axios.put(`billing-config/tox-payer-group-rules/${this.toxPayerGroupForm._id}`, payload)
          successNotification("Tox payer group rule updated")
        }
        this.showToxPayerGroupDialog = false
        this.fetchToxPayerGroupRules()
      } catch {
        errorNotification("Failed to save tox payer group rule")
      } finally {
        this.toxPayerGroupSaving = false
      }
    },

    async deleteToxPayerGroupRule(row) {
      try {
        await ElMessageBox.confirm(
          `Delete group "${row.group_name}"? This cannot be undone.`,
          "Confirm Delete",
          { confirmButtonText: "Delete", cancelButtonText: "Cancel", type: "warning" }
        )
        await axios.delete(`billing-config/tox-payer-group-rules/${row._id}`)
        successNotification("Tox payer group rule deleted")
        this.fetchToxPayerGroupRules()
      } catch (e) {
        if (e !== "cancel") errorNotification("Failed to delete tox payer group rule")
      }
    },

    async saveToxPolicyPrefixRule() {
      this.toxPolicyPrefixSaving = true
      try {
        const payload = {
          rule_name: this.toxPolicyPrefixForm.rule_name,
          policy_prefixes: this.toxPolicyPrefixForm.policy_prefixes.filter(v => v.trim()),
          cpt_codes: this.toxPolicyPrefixForm.cpt_codes.filter(c => c.cpt_code),
          total_sum: this.toxPolicyPrefixForm.total_sum,
          is_active: this.toxPolicyPrefixForm.is_active,
        }
        if (this.toxPolicyPrefixIsNew) {
          await axios.post("billing-config/tox-policy-prefix-rules", payload)
          successNotification("Tox policy prefix rule created")
        } else {
          await axios.put(`billing-config/tox-policy-prefix-rules/${this.toxPolicyPrefixForm._id}`, payload)
          successNotification("Tox policy prefix rule updated")
        }
        this.showToxPolicyPrefixDialog = false
        this.fetchToxPolicyPrefixRules()
      } catch {
        errorNotification("Failed to save tox policy prefix rule")
      } finally {
        this.toxPolicyPrefixSaving = false
      }
    },

    async deleteToxPolicyPrefixRule(row) {
      try {
        await ElMessageBox.confirm(
          `Delete rule "${row.rule_name}"? This cannot be undone.`,
          "Confirm Delete",
          { confirmButtonText: "Delete", cancelButtonText: "Cancel", type: "warning" }
        )
        await axios.delete(`billing-config/tox-policy-prefix-rules/${row._id}`)
        successNotification("Tox policy prefix rule deleted")
        this.fetchToxPolicyPrefixRules()
      } catch (e) {
        if (e !== "cancel") errorNotification("Failed to delete tox policy prefix rule")
      }
    },

    resetPayerCptForm() {
      this.payerCptForm = null
      this.payerCptIsNew = false
    },

    removeStringItem(arr, idx) {
      arr.splice(idx, 1)
    },

    addCptCodeRow() {
      this.sendoutForm.cpt_codes.push({ code: "", category: "", billed_value: null, unit: 1, total: null })
    },

    removeCptCodeRow(idx) {
      this.sendoutForm.cpt_codes.splice(idx, 1)
    },

    recalcTotal(item) {
      if (item.billed_value != null && item.unit != null) {
        item.total = Math.round(item.billed_value * item.unit * 100) / 100
      }
    },

    recalcPrefixTotal(item) {
      if (item.charge != null && item.unit != null) {
        item.total = Math.round(item.charge * item.unit * 1000) / 1000
      }
    },

    resetSendoutForm() {
      this.sendoutForm = null
      this.sendoutIsNew = false
    },

    resetToxPayerGroupForm() {
      this.toxPayerGroupForm = null
      this.toxPayerGroupIsNew = false
    },

    resetToxPolicyPrefixForm() {
      this.toxPolicyPrefixForm = null
      this.toxPolicyPrefixIsNew = false
    },

    onIcdSearchInput(val) {
      clearTimeout(this.icdSearchTimer)
      this.showIcdDropdown = true
      // Clear old results immediately when starting a new search
      this.icdCodeOptions = []
      this.icdSearchTimer = setTimeout(() => {
        this.icdCurrentQuery = val
        this.icdPage = 1
        this.icdHasMore = true
        this.loadIcdCodes(false)
      }, 300)
    },

    toggleIcdCode(form, code) {
      const idx = form.icd_codes.indexOf(code)
      if (idx === -1) {
        form.icd_codes.push(code)
      } else {
        form.icd_codes.splice(idx, 1)
      }
    },

    removeIcdCode(form, code) {
      const idx = form.icd_codes.indexOf(code)
      if (idx !== -1) {
        form.icd_codes.splice(idx, 1)
      }
    },

    restoreIcdCode(form, code) {
      if (!form.icd_codes.includes(code)) {
        form.icd_codes.push(code)
      }
    },

    addIcdCode(form, code) {
      if (!form.icd_codes.includes(code)) {
        form.icd_codes.push(code)
      }
    },

    addSearchedIcdCode(form) {
      const code = this.icdSearchQuery.trim().toUpperCase()
      if (code && !form.icd_codes.includes(code)) {
        form.icd_codes.push(code)
      }
      this.icdSearchQuery = ""
      this.showIcdDropdown = false
    },

    removeSearchedIcdCode(form) {
      const code = this.icdSearchQuery.trim().toUpperCase()
      const idx = form.icd_codes.indexOf(code)
      if (idx !== -1) {
        form.icd_codes.splice(idx, 1)
      }
      this.icdSearchQuery = ""
      this.showIcdDropdown = false
    },

    onIcdDropdownScroll(e) {
      const { scrollTop, scrollHeight, clientHeight } = e.target
      if (scrollTop + clientHeight >= scrollHeight - 40 && !this.icdSearchLoading && this.icdHasMore) {
        this.loadIcdCodes(true)
      }
    },

    async loadIcdCodes(append = false) {
      if (append && !this.icdHasMore) return
      if (this.icdSearchLoading) return
      this.icdSearchLoading = true
      try {
        const params = { page: this.icdPage, limit: 30 }
        if (this.icdCurrentQuery && this.icdCurrentQuery.trim()) {
          params.search_string = this.icdCurrentQuery.trim()
        }
        await this.$store.dispatch("icd10Codes/fetAllIcd10Codes", params)
        // Deduplicate API results
        const seenCodes = new Set()
        const apiResults = (this.getAllIcd10Codes.data || [])
          .map((el) => ({
            code: el.code,
            description: el.description || "",
          }))
          .filter((item) => {
            if (seenCodes.has(item.code)) return false
            seenCodes.add(item.code)
            return true
          })
        this.icdHasMore = apiResults.length === 30
        if (append) {
          const existingCodes = new Set(this.icdCodeOptions.map((o) => o.code))
          const newItems = apiResults.filter((r) => !existingCodes.has(r.code))
          this.icdCodeOptions = [...this.icdCodeOptions, ...newItems]
        } else {
          this.icdCodeOptions = apiResults
        }
        this.icdPage++
      } catch (e) {
        errorNotification("Failed to load ICD codes")
      } finally {
        this.icdSearchLoading = false
      }
    },

    async saveCptMapping() {
      this.saving = true
      try {
        const payload = {
          all_covered: this.cptForm.all_covered,
          icd_codes: this.cptForm.all_covered ? [] : this.cptForm.icd_codes,
        }
        await axios.put(
          `cpt-icd-mappings/lab/${this.getUserPrimaryLabId}/cpt/${this.cptForm.cpt_code}`,
          payload
        )
        successNotification("CPT mapping updated")
        this.showCptDialog = false
        this.fetchCptMappings()
      } catch {
        errorNotification("Failed to update CPT mapping")
      } finally {
        this.saving = false
      }
    },

    async saveIcdMapping() {
      this.saving = true
      try {
        const payload = {
          categories: this.icdForm.categories,
          icd_codes: this.icdForm.icd_codes,
        }
        await axios.put(
          `cpt-icd-mappings/icd-coverage/${this.icdForm.case_type}`,
          payload
        )
        successNotification("ICD case type mapping updated")
        this.showIcdDialog = false
        this.fetchIcdMappings()
      } catch {
        errorNotification("Failed to update ICD mapping")
      } finally {
        this.saving = false
      }
    },

    resetCptForm() {
      this.cptForm = null
      this.cptFormOriginalIcdCodes = []
      this.icdCodeOptions = []
      this.icdPage = 1
      this.icdHasMore = true
      this.icdCurrentQuery = ""
      this.icdSearchQuery = ""
      this.showIcdDropdown = false
    },

    resetIcdForm() {
      this.icdForm = null
      this.icdFormOriginalIcdCodes = []
      this.icdCodeOptions = []
      this.icdPage = 1
      this.icdHasMore = true
      this.icdCurrentQuery = ""
      this.icdSearchQuery = ""
      this.showIcdDropdown = false
    },

    formatDate(date) {
      if (!date) return "--"
      return moment(date).format("MM/DD/YYYY HH:mm")
    },
  },
}
</script>

<style scoped>
.tab-toolbar {
  display: flex;
  justify-content: flex-end;
  padding: 8px 0;
}

.icd-codes-preview {
  display: block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 100%;
}

.icd-more-badge {
  display: inline-block;
  margin-left: 6px;
  padding: 1px 6px;
  background: #e8f4fd;
  color: #409eff;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
}

.icd-selected-count {
  margin-top: 4px;
  font-size: 12px;
  color: #909399;
}

/* Constrain multi-select tag areas to prevent dialog overflow */
:deep(.el-select__tags) {
  max-height: 80px;
  overflow-y: auto;
  flex-wrap: wrap;
}

.json-textarea :deep(textarea) {
  font-family: monospace;
  font-size: 12px;
}

.cpt-rows-header {
  display: flex;
  gap: 6px;
  padding: 0 0 4px 0;
  font-size: 11px;
  font-weight: 600;
  color: #909399;
  text-transform: uppercase;
}

.cpt-code-row {
  display: flex;
  gap: 6px;
  align-items: center;
  margin-bottom: 6px;
}

.string-list {
  width: 100%;
}

.string-list-row {
  display: flex;
  gap: 6px;
  align-items: center;
  margin-bottom: 6px;
}

.icd-selector {
  width: 100%;
  position: relative;
}

.icd-dropdown {
  position: absolute;
  z-index: 2000;
  width: 100%;
  max-height: 240px;
  overflow-y: auto;
  background: #fff;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  margin-top: 4px;
}

.icd-option {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  cursor: pointer;
  font-size: 13px;
  line-height: 1.4;
  transition: background 0.15s;
}

.icd-option:hover {
  background: #f5f7fa;
}

.icd-option.is-selected {
  background: #ecf5ff;
  color: #409eff;
}

.icd-option-code {
  font-weight: 600;
  flex-shrink: 0;
}

.icd-option-desc {
  color: #909399;
  margin-left: 4px;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.icd-option.is-selected .icd-option-desc {
  color: #79bbff;
}

.icd-option-add-btn,
.icd-option-remove-btn {
  margin-left: auto;
  flex-shrink: 0;
  padding: 4px 10px;
  border: none;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s;
}

.icd-option-add-btn {
  background: #e1f3d8;
  color: #67c23a;
}

.icd-option-add-btn:hover {
  background: #67c23a;
  color: #fff;
}

.icd-option-remove-btn {
  background: #fef0f0;
  color: #f56c6c;
}

.icd-option-remove-btn:hover {
  background: #f56c6c;
  color: #fff;
}

.icd-loading-row {
  padding: 12px;
  text-align: center;
  font-size: 13px;
  color: #909399;
}

.icd-dropdown-close {
  position: sticky;
  top: 0;
  text-align: right;
  padding: 4px 8px;
  background: #fff;
  cursor: pointer;
  font-size: 16px;
  color: #909399;
  border-bottom: 1px solid #f0f0f0;
}

/* Selected ICD Codes List */
.icd-selected-list {
  margin-top: 12px;
  padding: 12px;
  background: #f5f7fa;
  border: 1px solid #e4e7ed;
  border-radius: 6px;
  max-height: 200px;
  overflow-y: auto;
}

.icd-selected-header {
  font-size: 12px;
  font-weight: 600;
  color: #606266;
  margin-bottom: 10px;
}

.icd-selected-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.icd-selected-tag {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  background: #e8f4fd;
  color: #409eff;
  border: 1px solid #b3d8ff;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 500;
}

.icd-tag-remove {
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
  color: #f56c6c;
  line-height: 1;
  transition: color 0.15s;
}

.icd-tag-remove:hover {
  color: #dd3333;
}

.icd-search-results {
  margin-top: 10px;
  max-height: 250px;
  overflow-y: auto;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  padding: 8px;
  background: #fff;
}

.icd-checkbox-row {
  padding: 6px 8px;
  border-radius: 4px;
  transition: background 0.15s;
}

.icd-checkbox-row:hover {
  background: #f5f7fa;
}

.icd-code {
  font-weight: 600;
  color: #303133;
}

.icd-desc {
  color: #909399;
  font-size: 12px;
}

.icd-simple-selector {
  display: flex;
  align-items: center;
  gap: 10px;
}

.icd-count {
  color: #909399;
  font-size: 13px;
  margin-top: 6px;
}

.icd-result-row {
  display: flex;
  align-items: center;
  padding: 8px 10px;
  border-radius: 4px;
  transition: background 0.15s;
}

.icd-result-row:hover {
  background: #f5f7fa;
}

.icd-result-code {
  font-weight: 600;
  color: #303133;
  flex-shrink: 0;
}

.icd-result-desc {
  color: #909399;
  font-size: 12px;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-right: 10px;
}

.icd-result-row .el-button {
  margin-left: auto;
  flex-shrink: 0;
}
</style>
